import script from "./IndexPart5.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPart5.vue?vue&type=script&setup=true&lang=js"

import "./IndexPart5.vue?vue&type=style&index=0&id=8151846a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8151846a"]])

export default __exports__